import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardPageResolver } from '@modules/reports/containers/dashboard/dashboard-page.resolver';
import { DashboardContainerComponent } from '@modules/reports/containers/dashboard/dashboard.container';
import { ReferralReportsListContainerComponent } from '@modules/reports/containers/referral-reports-list/referral-reports-list.container';
import { ReportsResolver } from '@modules/reports/reports.resolver';
import { ReportsPageContainerComponent } from '@modules/reports/containers/reports-page/reports-page.container';
import { PipelinePageContainerComponent } from '@modules/reports/containers/pipeline/pipeline-page.container';
import { PipelinePageResolver } from '@modules/reports/containers/pipeline/pipeline-page.resolver';

export const reportsRoutes: Routes = [
  {
    path: '',
    component: ReportsPageContainerComponent,
    children: [
      //TODO change redirectTo value to dashboard subpage
      { path: '', redirectTo: 'pipeline', pathMatch: 'full' },
      {
        path: 'referral-reports',
        component: ReferralReportsListContainerComponent,
        resolve: [ReportsResolver],
      },
      {
        path: 'pipeline',
        component: PipelinePageContainerComponent,
        resolve: [PipelinePageResolver],
      },
      {
        path: 'dashboard',
        component: DashboardContainerComponent,
        resolve: [DashboardPageResolver],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(reportsRoutes)],
  exports: [RouterModule],
  providers: [ReportsResolver, PipelinePageResolver, DashboardPageResolver],
})
export class ReportsRoutingModule {}
